import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Activity } from 'lucide-react';

export const Route = createFileRoute('/admin-console/monitoring')({
    staticData: {
        permissions: ['admin_orgs:read', 'admin_users:read', 'admin_system:read', 'admin_ai:read', 'audit_trail:read'],
        breadcrumb: {
            title: 'Monitoring',
            inactive: true,
        },
        ui: {
            icon: Activity,
            title: 'Monitoring and reporting',
            menuDescription: 'Monitor system activity and reports',
        },
    },
    component: Outlet,
});
